import { FormGroup, FormGroupFeedback, IFormGroupProps, Intent } from '@pinpointhq/thumbtack';
import { Field, FieldHelperProps, FieldInputProps, FieldMetaProps, useField } from 'formik';
import * as React from 'react';
import Image from '../../../form/formik/fields/Image';
import { SingleFileInput } from './FileField';

interface IFilePreviewFieldProps {
  accept: string[];
  maxSizeKB: number;
  name: string;
  formGroupProps?: Omit<IFormGroupProps, 'labelFor'>;
}

export default function FilePreviewField({ accept, name, formGroupProps, maxSizeKB }: IFilePreviewFieldProps) {
  const [field, meta, helpers]: [FieldInputProps<string>, FieldMetaProps<string>, FieldHelperProps<string>] =
    useField<string>(name);
  const hasError = meta.touched && meta.error;
  return (
    <FormGroup {...formGroupProps}>
      <Field accept={accept} component={Image} maxSizeKB={maxSizeKB} name={name} uploader="activestorage" />
      {hasError && <FormGroupFeedback intent={Intent.DANGER}>{meta.error}</FormGroupFeedback>}
    </FormGroup>
  );
}
